const mediaItems = [
  {
    title: '2024年度漫画推荐大盘点',
    desc: '回顾这一年最值得看的漫画作品，韩漫日漫国漫年度十佳榜单揭晓。',
    icon: 'ri-award-line',
    label: '年度盘点',
  },
  {
    title: '新手入坑指南：漫画分类全解析',
    desc: '不知道从哪部开始看？这份分类指南帮你快速找到喜欢的漫画类型。',
    icon: 'ri-book-open-line',
    label: '阅读指南',
  },
  {
    title: '热门漫画作者深度访谈',
    desc: '对话当红漫画作者，了解创作背后的故事与灵感来源，走近漫画世界。',
    icon: 'ri-mic-line',
    label: '作者访谈',
  },
  {
    title: '每周漫评：新番速递与追更建议',
    desc: '每周精选最新漫画连载点评，告诉你哪些作品值得追、哪些可以养肥再看。',
    icon: 'ri-chat-smile-2-line',
    label: '每周漫评',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            漫画资讯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            漫画推荐指南、新番点评与阅读攻略，帮你更好享受漫画世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group block bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <span className="w-6 h-6 flex items-center justify-center text-primary-600 text-xl">
                  <i className={item.icon}></i>
                </span>
              </div>
              <span className="inline-block px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                {item.label}
              </span>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}